<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>
<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<div fxLayout="column">


  <ng-container *ngIf="dataSource else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
    </div>

    <!-- <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar> -->

    <table (matSortChange)="doSortInvoices($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>

      <ng-container matColumnDef="idInvoice">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Id Invoice </th>
        <td *matCellDef="let element" mat-cell>
          <label>{{element.id}}</label>
        </td>
      </ng-container>
      <ng-container matColumnDef="invoiceNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Invoice number </th>
        <td *matCellDef="let element" mat-cell>
          <mat-form-field *ngIf="showEdit[element.id]" class="example-full-width" appearance="fill">
            <input matInput placeholder="Invoice #" [value]="element.invoiceNumber" [(ngModel)]="element.invoiceNumber">
          </mat-form-field>
          <label *ngIf="!showEdit[element.id]">{{element.invoiceNumber}}</label>
        </td>
      </ng-container>
      <ng-container matColumnDef="company">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Company </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.company.companyName}}</td>
      </ng-container>
      <ng-container matColumnDef="contractDescription">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Contract Description </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.description}}</td>
      </ng-container>
      <ng-container matColumnDef="refContract">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Reference Contract </th>
        <td *matCellDef="let element" mat-cell>{{element.identifier}}</td>
      </ng-container>
      <ng-container matColumnDef="contractBoxNumbers">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Box Numbers </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.numberOfBoxes}}</td>
      </ng-container>
      <!-- Contract Type Column -->
      <ng-container matColumnDef="contractType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Contract Type</th>
        <td *matCellDef="let element" mat-cell class="uppercase"> {{element.contract.thirdPartyContract ?
          contractTypes.partnership : contractTypes.directContract | splitCamelCase}} </td>
      </ng-container>
      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let element" mat-cell> {{element.contract.startDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>
      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let element" mat-cell> {{element.contract.endDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>


      <ng-container matColumnDef="paid">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Paid </th>

        <td *matCellDef="let element" mat-cell>
          <mat-slide-toggle class="toggleCheck" [disabled]="!(loggedUser.role === roles.admin)"
            (change)="editSatusIsPayed(element)" [checked]="element.isPayed">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td mat-cell *matCellDef="let element" class="text-right">
          <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
            <mat-icon>visibility</mat-icon>
          </button>
          <button (click)="deleteInvoiceSetup(element)" [disabled]="!(loggedUser.role === roles.admin)" mat-icon-button
            matTooltip="Delete invoice">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button [disabled]="!(loggedUser.role === roles.admin)"
            (click)="sendNotificationForPayment(element)" matTooltip="Send notification">
            <mat-icon>notifications</mat-icon>
          </button>
          <button mat-icon-button (click)="generatePDF(element)" matTooltip="Download invoice">
            <mat-icon>download</mat-icon>
          </button>
          <button *ngIf="!showEdit[element.id]" [disabled]="!(loggedUser.role === roles.admin)" mat-icon-button
            (click)="updateInvoiceNumber(element)" matTooltip="Edit number">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button *ngIf="showEdit[element.id]" [disabled]="!(loggedUser.role === roles.admin)"
            (click)="saveInvoiceNumber(element)" matTooltip="Save number">
            <mat-icon>save</mat-icon>
          </button>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="headers" mat-header-row></tr>
      <tr *matRowDef="let row; columns: headers" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="headers.length" class="mat-cell text-center">
          No invoices found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorItems [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>